import { useState, useEffect } from 'react';
import { __ } from '@wordpress/i18n';
import { Placeholder, Spinner } from '@wordpress/components';

import { BplMediaPlaceholder } from '../../Components';
import { tabController } from '../../Components/utils/functions';

import Settings from './Settings';
import Style from './Style';
import ViewSDKClient from './ViewSDKClient';
import SettingsSaveForm from './SettingsSaveForm';
import useWPOptionQuery from './hooks/useWPOptionQuery';
import useWPOptionMutation from './hooks/useWPOptionMutation';

const Edit = props => {
	const { className, attributes, setAttributes, clientId, isSelected } = props;
	const { file, config } = attributes;

	const [status, setStatus] = useState(null);
	const { data: apiKey, isLoading: dataLoading } = useWPOptionQuery('pebAPIKey', status);
	const { saveData, isLoading } = useWPOptionMutation('pebAPIKey', { type: 'string' }, setStatus);

	useEffect(() => { clientId && setAttributes({ cId: clientId.substring(0, 10) }); }, [clientId]); // Set & Update clientId to cId

	useEffect(() => tabController(), [isSelected]);

	// useEffect(() => {
	// 	saveData(apiKey);
	// }, [apiKey]);

	// Init ViewSDKClient
	useEffect(() => {
		if (apiKey && file.url) {
			const viewSDKClient = new ViewSDKClient();

			viewSDKClient.ready().then(() => {
				viewSDKClient.previewFile(`pebPDFArea-${clientId}`, { embedMode: config?.embedMode }, attributes, apiKey);
			});
		}
	}, [apiKey, file, config?.embedMode]);

	// Check if Adobe API loaded
	if (dataLoading || isLoading) {
		return <div className='pebSpinnerContainer'><Spinner /> {__(' Loading', 'pdf-embed-block')}</div>
	}

	// <p>
	// 	{__('Generate a PDF Embed API Key (Client ID) from ', 'pdf-embed-block')}

	// 	<a href='https://documentcloud.adobe.com/dc-integration-creation-app-cdn/main.html?api=pdf-embed-api' target='_blank' rel='noreferrer'>{__('here', 'pdf-embed-block')}</a>

	// 	{__('. Amd insert the Client ID in the field of in the settings panel on the right.', 'pdf-embed-block')}
	// </p>

	return <>
		<Settings attributes={attributes} setAttributes={setAttributes} data={apiKey} dataLoading={dataLoading} saveData={saveData} isLoading={isLoading} />

		{!apiKey ?
			<Placeholder className='bplMediaPlaceholder pebPDFPlaceholder' label={__(`API Key (Client ID)`, 'pdf-embed-block')} icon='pdf'>
				<p>
					{__('Generate a PDF Embed API Key (Client ID) from ', 'pdf-embed-block')}

					<a href='https://documentcloud.adobe.com/dc-integration-creation-app-cdn/main.html?api=pdf-embed-api' target='_blank' rel='noreferrer'>{__('here', 'pdf-embed-block')}</a>

					{__('. Amd insert the Client ID in the field of in the settings panel on the right.', 'pdf-embed-block')}
				</p>

				<div className='pdfSettingsForm'>
					<SettingsSaveForm data={apiKey} dataLoading={dataLoading} saveData={saveData} isLoading={isLoading} />
				</div>
			</Placeholder> :

			file?.url ? <div className={className} id={`pebPDFEmbed-${clientId}`}>
				<Style attributes={attributes} clientId={clientId} />

				<div className='pebPDFEmbed'>
					{'SIZED_CONTAINER' === config?.embedMode && <div className='pebSizedContainer' id={`pebPDFArea-${clientId}`}></div>}

					{'IN_LINE' === config?.embedMode && <div className='pebInLine' id={`pebPDFArea-${clientId}`}></div>}
				</div>
			</div> :

				<BplMediaPlaceholder type='application/pdf' typeName='PDF' icon='pdf' onChange={val => setAttributes({ file: val })} placeholder={__('Paste or type a PDF URL', 'pdf-embed-block')} />}
	</>;
};
export default Edit;
// export default compose(
// 	withSelect((select) => {
// 		return {
// 			// settingsPage: `${select('core')?.getSite()?.url}/wp-admin/options-general.php?page=pdf-embed-settings`,
// 			getAPI: select('peb/api').getAPI()
// 		}
// 	}),
// 	withDispatch((dispatch) => {
// 		return {
// 			setAPI: api => dispatch('peb/api').setAPI(api)
// 		}
// 	})
// )(Edit);